import { createGlobalStyle } from 'styled-components';
import { globalStyleAdjustmentsCss } from './globalStyleAdjustmentsCss';
import { designTokens } from './designTokens';
import { clickRegionGlobalStyles } from '../components/ClickRegion/globalStyles';

export const GlobalStyle = createGlobalStyle`
  ${globalStyleAdjustmentsCss}
  ${designTokens}
  ${clickRegionGlobalStyles}
`;
